// Client-side multi-step navigation controller.
// Shows/hides step panels and tracks the current step index.
//
// Usage:
// <div data-controller="stepper" data-stepper-index-value="0">
//   <div data-stepper-target="step" data-step="0">Step 1 content</div>
//   <div data-stepper-target="step" data-step="1">Step 2 content</div>
//   <div data-stepper-target="step" data-step="2">Step 3 content</div>
//   <button data-action="stepper#next">Next</button>
//   <button data-action="stepper#prev">Back</button>
// </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]
  static values = {
    index: { type: Number, default: 0 },
  }

  connect() {
    this.showCurrentStep()
  }

  next() {
    if (this.indexValue < this.stepTargets.length - 1) {
      this.indexValue++
    }
  }

  prev() {
    if (this.indexValue > 0) {
      this.indexValue--
    }
  }

  indexValueChanged() {
    this.showCurrentStep()
  }

  showCurrentStep() {
    this.stepTargets.forEach((step, i) => {
      step.classList.toggle("hidden", i !== this.indexValue)
    })

    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
